import type { OnlineStatus } from '../types';
import { useI18n } from '../i18n';

interface ClosedOverlayProps {
  status: OnlineStatus;
}

export function ClosedOverlay({ status }: ClosedOverlayProps) {
  const { t } = useI18n();
  const isPaused = status.is_paused;

  return (
    <div className="hc-closed-overlay">
      <div className="hc-closed-icon">{isPaused ? '\u23F8' : '\uD83D\uDD50'}</div>
      <h2 className="hc-closed-title">
        {isPaused ? t('closed.paused') : t('closed.outsideHours')}
      </h2>
      {!isPaused && status.schedule.length > 0 && (
        <div className="hc-schedule">
          <h3 className="hc-schedule-title">{t('closed.schedule')}</h3>
          <div className="hc-schedule-list">
            {status.schedule.map((entry) => (
              <div key={entry.day} className="hc-schedule-row">
                <span className="hc-schedule-day">{t(`day.${entry.day}` as any)}</span>
                <span className="hc-schedule-time">
                  {entry.active ? `${entry.open} - ${entry.close}` : '—'}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
